module.exports = __webpack_public_path__ + "img/on_mobile_games.6958e2c5.png";